export const api = { idle: "idle", pending: "pending", resolved: "resolved", rejected: "rejected" } as const;

// # Types
export const grid = {
   sizes: { xxl: "xxl", xl: "xl", l: "l", m: "m", s: "s", xs: "xs" } as const,
};

export const toolMenuStatuses = {
   open: "open",
   close: "close",
};

export const dataScrollStatuses = {
   none: "none",
   endArea: "endArea",
   end: "end",
};

export const XSSearchStatuses = {
   idle: "idle",
   openInit: "openInit",
   closeInit: "closeInit",
   input: "input",
};

export const dataTypes = {
   key: "key",
   keys: "keys",
   data: "data",
   number: "number",
   string: "string",
   datetime: "datetime",
   uri: "uri",
   img: "img",
   file: "file",
   select: "select",
   json: "json",
   other: "other",
};
// key는 검색, datetime은 캘린더, uri는 상대 주소 절대 주소 확인, img는 이미지 드래그 업로더 포함, select는 선택형, json이나 array 등등은 ','로 구분하는 것들, 지역 정보는 다음 지도 검색 연동,
